import { Field, Fieldset, Label } from "@headlessui/react";
import { Button } from "../tailwind/button";
import { Input } from "../tailwind/input";
import { Link } from "react-router-dom";
import { Checkbox } from "antd";
import { cleanPhone } from "../../functions/cleanPhone";

export const SignUpForm = ({
  companyCode,
  setCompanyCode,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  email,
  setEmail,
  password,
  setPassword,
  phone,
  setPhone,
  errors,
  checked,
  onChange,
  handleSubmit,
  isLoading,
  hideNameFields = false,
  buttonText = "Sign Up",
}) => {
  return (
    <form className="space-y-6" onSubmit={handleSubmit}>
      <Fieldset>
        <Field>
          <Label>Company Invitation Code</Label>
          <Input
            name="companyCode"
            type="text"
            disabled
            value={companyCode}
            onChange={(e) => setCompanyCode(e.target.value)}
            {...(errors.companyCode && { "data-invalid": true })}
          />
          {errors.companyCode && (
            <p className="text-red-500 text-xs mt-1">{errors.companyCode}</p>
          )}
        </Field>
        <br />

        {!hideNameFields && (
          <div className="grid grid-cols-2 gap-4 mb-5">
            <Field>
              <Label>First Name</Label>
              <Input
                name="firstName"
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                {...(errors.firstName && { "data-invalid": true })}
              />
              {errors.firstName && (
                <p className="text-red-500 text-xs mt-1">{errors.firstName}</p>
              )}
            </Field>
            <Field>
              <Label>Last Name</Label>
              <Input
                name="lastName"
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                {...(errors.lastName && { "data-invalid": true })}
              />
              {errors.lastName && (
                <p className="text-red-500 text-xs mt-1">{errors.lastName}</p>
              )}
            </Field>
          </div>
        )}

        <Field>
          <Label>Email Address</Label>
          <Input
            name="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            {...(errors.email && { "data-invalid": true })}
          />
          {errors.email && (
            <p className="text-red-500 text-xs mt-1">{errors.email}</p>
          )}
        </Field>
        <br />
        <Field>
          <Label>Password</Label>
          <Input
            name="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            {...(errors.password && { "data-invalid": true })}
          />
          {errors.password && (
            <p className="text-red-500 text-xs mt-1">{errors.password}</p>
          )}
        </Field>
        <br />
        {!hideNameFields && (
          <>
            <Field>
              <Label>Phone Number - to receive test messages</Label>
              <Input
                value={phone}
                maxLength={15}
                onChange={(e) =>
                  setPhone(cleanPhone(e.target.value.replace(/[^0-9]/g, "")))
                }
                autoComplete="off"
              />
            </Field>
            <br />
          </>
        )}

        <Checkbox checked={checked} onChange={onChange}>
          I accept Simio's{" "}
          <Link
            to="https://getsimio.notion.site/Terms-Conditions-2c0d2f17fde14ae29052a64f82636aca"
            target="_blank"
          >
            Terms and Conditions
          </Link>
        </Checkbox>
      </Fieldset>

      <Button
        type="submit"
        color="primaryButton"
        className="flex w-full justify-center bg-yellow font-title font-bold leading-6 "
        loading={isLoading}
        disabled={!checked}
      >
        {buttonText}
      </Button>
    </form>
  );
};
